import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpenInfoComponent } from './open-info/open-info.component';
import { OpenInfoEquipmentComponent } from './open-info-equipment/open-info-equipment.component';
import {RouterOutlet} from '@angular/router';
import {OpenInfoRoutingModule} from '@app/open-info/open-info-routing.module';
import {MatCardModule} from '@angular/material/card';
import {PipesModule} from '@shared/pipes/pipes.module';
import {MaterialModule} from '@shared/material.module';



@NgModule({
  declarations: [
    OpenInfoComponent,
    OpenInfoEquipmentComponent
  ],
  imports: [
    CommonModule,
    OpenInfoRoutingModule,
    RouterOutlet,
    MatCardModule,
    PipesModule,
    MaterialModule
  ]
})
export class OpenInfoModule { }
